import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-maintenance-banner',
  template: `
    <div *ngIf="maintenance && bannerVisible" class="maintenance-banner">
      <div class="banner-content">
        <span class="maintenance-icon"><i class="fas fa-tools"></i></span>
        <div class="banner-text">
          <span class="banner-title">{{ maintenance.title }}</span>
          <span class="banner-desc">{{ maintenance.content }}</span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./maintenance-banner.component.scss']
})
export class MaintenanceBannerComponent implements OnInit {
  maintenance: any;
  bannerVisible: boolean;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.loadNotifications();
    // Refresh every 5 minutes
    // setInterval(() => this.loadNotifications(), 300000);
  }

  private loadNotifications() {
    this.dataService.getActiveSystemNotifications().subscribe(
      (response: any) => {
        this.maintenance = response.maintenance;
        this.bannerVisible = this.maintenance ? true : false;
      }
    );
  }
}